const Us = () => {
  return (
    <div className='flex items-center justify-center pb-5'>
      <div className='tracking-normal text-xl sm:text-4xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-7xl'>
        <h1 className='text-slate-50 pt-5 pb-2 flex items-center justify-center font-bold text-3xl sm:text-6xl sm:pb-5 md:text-7xl lg:text-8xl xl:text-8xl 2xl:text-9xl'>US National Anthem</h1>
        <p className='text-slate-300 pt-5 leading-tight'>
          Oh, say can you see,<br />
          By the dawn's early light,<br />
          What so proudly we hailed<br />
          At the twilight's last gleaming,<br />
          Whose broad stripes and bright stars,<br />
          Thru the perilous fight,<br />
          O'er the ramparts we watched<br />
          Were so gallantly streaming?<br />
          And the rockets red glare,<br />
          The bombs bursting in air,<br />
          Gave proof through the night<br />
          That our flag was still there.<br />
          O, say, does that<br />
          Star-Spangled Banner yet wave<br />
          O'er the land of the free<br />
          And the home of the brave?
        </p>
      </div>
    </div>
  )
}

export default Us
